(function () {
  // Keep the first three upsell cards visible; cards after that are collapsed.
  const VISIBLE_CARDS = 3;
  const SELECTOR_LIST = '.lb-list';
  // The Selleasy markup contains an inner `.lb-flat-card` inside each host.
  // Only count the host cards so one product is not counted twice.
  const SELECTOR_CARD = 'lb-upsell-flat-card';

  // ====== 新增：标题选择器 ======
  const SELECTOR_TITLE = '.lb-title-toggle';

  function getText(root, selectors) {
    for (const selector of selectors) {
      const text = root.querySelector(selector)?.textContent?.trim();
      if (text) return text;
    }
    return '';
  }

  function escapeHTML(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // 读取 gift-box 内容，转换成 lb-list 能用的卡片
  function buildGiftCards() {
    const giftBox = document.querySelector('.custom-gift-box ul');
    if (!giftBox) return [];

    const items = Array.from(giftBox.querySelectorAll('li'));

    return items.map(li => {
      const img = li.querySelector('img')?.src || '';
      const title = getText(li, [
        '.custom-gift-description',
        '.text-base',
        '[data-gift-title]'
      ]) || li.querySelector('img')?.alt?.trim() || 'Free Gift';
      const price = getText(li, [
        '.custom-gift-free',
        '.custom-price div'
      ]) || 'Free';
      const safeTitle = escapeHTML(title);
      const safePrice = escapeHTML(price);
      const safeImg = escapeHTML(img);

      const wrapper = document.createElement('lb-upsell-flat-card');
      wrapper.className = "lb-flat-card lb-flat-cta-button-price";
      wrapper.style.cssText = `
        border-color: rgb(228, 231, 236);
        border-width: 0px;
        border-radius: 8px;
        gap: 8px;
        background-color: #fff;
        padding: 8px;
        margin: 4px 0px;
      `;

      wrapper.innerHTML = `
        <lb-card-image lb-preview="true" class="lb-image-host hydrated">
          <div class="lb-card-image-cont">
            <img class="lb-card-img lb-image-pd" alt="${safeTitle}" src="${safeImg}" style="border-radius: 4px;">
          </div>
        </lb-card-image>

        <div class="lb-cta-cont">

          <lb-card-title lb-preview="true" class="hydrated">
            <div class="lb-card-title-cont">
              <div class="lb-card-title lb-title-ld"
                style="font-size: 14px; font-weight: 400;">
                ${safeTitle}
              </div>
            </div>
          </lb-card-title>

          <lb-price class="hydrated">
            <div class="lb-price lb-price-sl-button">
              <div class="lb-price">
                <span class="lb-price-sale-price money"
                  style="font-size: 14px; font-weight: 600;">
                  ${safePrice}
                </span>
              </div>
            </div>
          </lb-price>

          <lb-button lb-action-product="" lb-action="" style="position: absolute;right: 10px;" class="lb-button-host lb-button-sm hydrated">
            <div class="lb-button-cont lb-button-sm">
              <div role="button" tabindex="0" class="lb-button"
                style="color:#fff;background-color:rgb(var(--color-sale-price));
                      border-radius:6px;font-size:14px;height:28px;">
                Free
              </div>
            </div>
          </lb-button>

        </div>
      `;

      return wrapper;
    });
  }


  function initList(listEl) {
    if (!listEl || listEl.dataset.smoreInit) return;
    listEl.dataset.smoreInit = 'true';

    // ==================================================
    // ⭐ 新增：标题折叠功能（完全不影响原逻辑）
    // ==================================================
    const titleEl =
      listEl.parentElement?.querySelector(SELECTOR_TITLE) ||
      listEl.previousElementSibling;

    if (titleEl && !titleEl.dataset.collapseInit) {
      titleEl.dataset.collapseInit = 'true';

      titleEl.style.cursor = 'pointer';
      titleEl.style.display = 'flex';
      titleEl.style.justifyContent = 'space-between';
      titleEl.style.alignItems = 'center';

      // icon
      const iconWrap = document.createElement('span');
      iconWrap.innerHTML = `
        <svg class="icon icon-chevron-up icon-xs shrink-0"
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="width:16px;height:16px;transition:transform .25s ease;">
          <path stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 15L12 9L18 15"></path>
        </svg>
      `;

      const icon = iconWrap.querySelector('svg');
      titleEl.appendChild(iconWrap);

      let collapsed = false;

      titleEl.addEventListener('click', () => {
        collapsed = !collapsed;

        if (collapsed) {
          listEl.style.display = 'none';
          icon.style.transform = 'rotate(180deg)';
        } else {
          listEl.style.display = '';
          icon.style.transform = 'rotate(0deg)';
        }
      });
    }

    // =======================
    // 原逻辑：gift 注入
    // =======================
    const giftCards = buildGiftCards();
    giftCards.forEach(card => listEl.prepend(card));

    const cards = Array.from(listEl.querySelectorAll(SELECTOR_CARD + ', .gift-card'));
    if (!cards.length) return;

    const imgs = Array.from(listEl.querySelectorAll('img'));
    const imgsLoaded = imgs.map(img =>
      img.complete ? Promise.resolve() : new Promise(r => img.onload = r)
    );

    Promise.all(imgsLoaded).then(() => {

      if (cards.length <= VISIBLE_CARDS) return;

      const hiddenCards = cards.slice(VISIBLE_CARDS);

      hiddenCards.forEach(card => card.style.display = 'none');

      let p = listEl.querySelector('.lb-showmore-wrapper');

      const extraCount = cards.filter(card =>
        getComputedStyle(card).display === 'none'
      ).length;

      if (!p) {
        p = document.createElement('p');
        p.className = 'lb-showmore-wrapper';
        p.innerHTML = `
          <span id="fbt-show-btn" style="cursor:pointer;">
            <span more="">Show more (${extraCount})</span>
            <span less="" style="display:none">Show less</span>
          </span>
        `;
        listEl.appendChild(p);
      }

      const btn = p.querySelector('#fbt-show-btn');
      let expanded = false;

      btn.addEventListener('click', () => {
        if (!expanded) {
          hiddenCards.forEach(card => card.style.display = '');
          btn.querySelector('[more]').style.display = 'none';
          btn.querySelector('[less]').style.display = '';
          expanded = true;
        } else {
          hiddenCards.forEach(card => card.style.display = 'none');
          btn.querySelector('[more]').style.display = '';
          btn.querySelector('[less]').style.display = 'none';
          expanded = false;
        }
      });

    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR_LIST).forEach(initList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  const bodyObserver = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (!m.addedNodes) return;
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches && node.matches(SELECTOR_LIST)) initList(node);
        else if (node.querySelectorAll)
          node.querySelectorAll(SELECTOR_LIST).forEach(initList);
      });
    });
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
